<template>
    <div>
        <LabeledControl class="mb3" label="Postal Code">
            <Textbox v-model="value.postalCode" @input="$emit('input', value)" :focused="true" />
        </LabeledControl>
        <LabeledControl class="mb3" label="Address">
            <Textbox v-model="value.address" @input="$emit('input', value)"/>
        </LabeledControl>
        <div class="flex pb4">
            <LabeledControl class="w-75" label="City">
                <Dropdown v-model="value.city" @input="$emit('input', value)">
                    <option>Winnipeg</option>
                </Dropdown>
            </LabeledControl>
            <LabeledControl class="ml4 w-25" label="Province">
                <Dropdown v-model="value.province" @input="$emit('input', value)">
                    <option>Manitoba</option>
                </Dropdown>
            </LabeledControl>
        </div>
    </div>

</template>

<script>
import LabeledControl from '@/components/controls/LabeledControl.vue';
import Textbox from '@/components/controls/Textbox.vue';
import Dropdown from '@/components/controls/Dropdown.vue';

export default {
    components: {
        LabeledControl,
        Textbox,
        Dropdown
    },
    props: {
        value: {
            type: Object
        }
    }
};
</script>
